import {ResolvedAskUser} from '../ResolvedAskUser'
import type {AskUserItem} from '../../../types/events'

/**
 * Renders a resolved ask_user prompt in the timeline.
 */
export function AskUser({item}: {item: AskUserItem}) {
  if (!item.completedEvent) return null

  const answer = item.completedEvent.data.answer ?? 'Response submitted'

  return <ResolvedAskUser question={item.question} resolvedAnswer={answer} />
}
